import React from "react";

const CommonButton = ({
  children,
  onClick,
  disabled = false,
  className = "",
  variant = "primary",
  type = "button",
  theme = "light",
  ...rest
}) => {
  const buttonStyles = {
    primary:
      "bg-[#236DB4] focus:ring-blue-300 dark:bg-blue-600 dark:focus:ring-blue-800",
    success:
      "bg-[#45B369] focus:ring-green-300 dark:bg-green-600 dark:focus:ring-green-700",
    danger:
      "bg-[#EE0014] focus:ring-red-300 dark:bg-red-600 dark:focus:ring-red-700",
    warning: "bg-[#F9B21D] focus:ring-yellow-500",
    gray: "bg-gray-500 focus:ring-gray-300",
    blue: "bg-blue-600 focus:ring-blue-400",
    red: "bg-[#EE0014] focus:ring-red-300 dark:bg-red-600 dark:focus:ring-red-800",
  };

  const themeStyles =
    theme === "dark"
      ? "dark-mode"
      : theme === "high-contrast"
      ? " border bg-black text-white"
      : "";

  return (
    <button
      type={type}
      disabled={disabled}
      className={`${className} px-4 py-3 gap-[10px] items-center inline-flex text-sm text-white focus:ring-4 focus:outline-none font-medium rounded-sm transition-all ${buttonStyles[variant]} ${themeStyles}`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
};

export default CommonButton;